import { render, staticRenderFns } from "./CourseAppoint.vue?vue&type=template&id=9b5b971a&"
import script from "./CourseAppoint.vue?vue&type=script&lang=js&"
export * from "./CourseAppoint.vue?vue&type=script&lang=js&"
import style0 from "./CourseAppoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports